import React, { useState } from "react";
import { Checkbox, Input, Button } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";

const FilterSection = ({ selectedFilters, setSelectedFilters }) => {
  const [minBudget, setMinBudget] = useState("");
  const [maxBudget, setMaxBudget] = useState("");

  const handlePriceApply = () => {
    const min = minBudget ? parseInt(minBudget) : 0;
    const max = maxBudget ? parseInt(maxBudget) : Infinity;
    setSelectedFilters((prev) => ({ ...prev, priceRange: [min, max] }));
  };

  const handleCheckboxChange = (field, values) => {
    setSelectedFilters((prev) => ({ ...prev, [field]: values }));
  };

  return (
    <div className="w-[270px] border border-[#CCE1F9] p-4 overflow-y-auto max-h-[90vh]">
      {/* Suggested For You */}
      <Section title="Suggested For You">
        <Checkbox.Group
          className="flex flex-col space-y-1"
          value={selectedFilters.cities}
          onChange={(val) => handleCheckboxChange("cities", val)}
        >
          {["Abu Dhabi", "Dubai", "Sharjah", "Ajman", "Ras Al Khaimah"].map(
            (city) => (
              <Checkbox key={city} value={city}>
                {city}
              </Checkbox>
            )
          )}
        </Checkbox.Group>
      </Section>

      {/* Price per night */}
      <Section title="Price per night">
        <Checkbox.Group
          onChange={(val) => {
            if (val.length) {
              const [min, max] = val[0].split("-").map((p) => parseInt(p.trim().replace("₹", "")));
              setSelectedFilters((prev) => ({
                ...prev,
                priceRange: [min, max || Infinity],
              }));
            }
          }}
          className="flex flex-col space-y-1"
        >
          {[
            "₹ 0 - ₹ 2000",
            "₹ 2000 - ₹ 4000",
            "₹ 4000 - ₹ 6000",
            "₹ 6000 - ₹ 9000",
            "₹ 9000 - ₹ 12000",
            "₹ 12000 - ₹ 15000",
            "₹ 15000 - ₹ 30000",
            "₹ 30000+",
          ].map((price) => (
            <Checkbox key={price}>{price}</Checkbox>
          ))}
        </Checkbox.Group>
      </Section>

      {/* Your Budget */}
      <Section title="Your Budget">
        <div className="flex items-center gap-2">
          <Input placeholder="Min" className="w-[70px]" value={minBudget} onChange={(e) => setMinBudget(e.target.value)} />
          <span>to</span>
          <Input placeholder="Max" className="w-[70px]" value={maxBudget} onChange={(e) => setMaxBudget(e.target.value)} />
          <Button type="primary" icon={<ArrowRightOutlined />} className="!bg-[#C1171C] !border-none" onClick={handlePriceApply} />
        </div>
      </Section>

      {/* Star Category */}
      <Section title="Star Category">
        <Checkbox.Group
          className="flex flex-col space-y-1"
          onChange={(val) => handleCheckboxChange("stars", val)}
        >
          {[3, 4, 5].map((star) => (
            <Checkbox key={star} value={star}>
              {star} Star
            </Checkbox>
          ))}
        </Checkbox.Group>
      </Section>

      {/* User Rating */}
      <Section title="User Rating">
        <Checkbox.Group
          className="flex flex-col space-y-1"
          onChange={(val) => handleCheckboxChange("ratings", val)}
        >
          {[4.2, 3.5, 3].map((r, i) => (
            <Checkbox key={i} value={r}>
              {r === 4.2
                ? "Excellent: 4.2+"
                : r === 3.5
                ? "Very Good: 3.5+"
                : "Good: 3+"}
            </Checkbox>
          ))}
        </Checkbox.Group>
      </Section>

      {/* Property Type */}
      <Section title="Property Type">
        <Checkbox.Group
          className="flex flex-col space-y-1"
          onChange={(val) => handleCheckboxChange("propertyTypes", val)}
        >
          {["Hotel", "Resort", "Apartment", "Villa", "Cottage"].map((type) => (
            <Checkbox key={type} value={type}>
              {type}
            </Checkbox>
          ))}
        </Checkbox.Group>
      </Section>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div className="mb-6">
    <h3 className="text-[15px] font-semibold mb-2 text-gray-800">{title}</h3>
    {children}
  </div>
);

export default FilterSection;
